import { render, staticRenderFns } from "./Expert2FieldReferenceEditModal.vue?vue&type=template&id=3f464a64&scoped=true&"
import script from "./Expert2FieldReferenceEditModal.vue?vue&type=script&lang=js&"
export * from "./Expert2FieldReferenceEditModal.vue?vue&type=script&lang=js&"
import style0 from "./Expert2FieldReferenceEditModal.vue?vue&type=style&index=0&id=3f464a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f464a64",
  null
  
)

export default component.exports